module.exports = __webpack_public_path__ + "img/serifnew_box23.f9d58a59.jpg";